<template>
  <v-row class="font-weight-bold caption">
    <v-chip
      label
      outlined
      small
      :color="primaryColor"
    >
      {{ label }}
    </v-chip>

    <span
      v-if="text"
      class="ml-2 my-auto"
    >
      {{ text }}
    </span>
  </v-row>
</template>

<script>
export default {
  name: 'ReleaseLabel',
  props: {
    text: {
      default: null,
      type: String,
      required: false,
    },
    type: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      primaryColorMap: {
        deprecated: 'toasted',
        fix: 'coolgray',
        new: 'primary',
        update: 'purple',
      },
      labelMap: {
        deprecated: 'Deprecated',
        fix: 'Fix',
        new: 'New',
        update: 'Update',
      },
    }
  },
  computed: {
    primaryColor() {
      return this.primaryColorMap[this.type]
    },
    label() {
      const { labelMap } = this

      return labelMap[this.type]
    },
  },
}
</script>
